import dayjs from "dayjs"
import { HistoryItem, OrderRequestActionCode } from "../pages/types"
import { ClockCircleOutlined, StopOutlined } from "@ant-design/icons"
import { ReactComponent as CASH } from "../assets/Euro.svg"
import { ReactComponent as DONE } from "../assets/DoneInCircle.svg"

export function humanizeOrderRequestActionCode(code: (typeof OrderRequestActionCode)[keyof typeof OrderRequestActionCode]["value"]) {
    const entries = Object.entries(OrderRequestActionCode) as [
        keyof typeof OrderRequestActionCode,
        (typeof OrderRequestActionCode)[keyof typeof OrderRequestActionCode]
    ][]
    for (const [, entry] of entries) {
        if (entry.value === code) {
            return entry.translation
        }
    }
}

export const transformHistoryIntoTimelineItems = (items: HistoryItem[]) => {
    return items.map((item) => ({
        children: (
            <div className="flex leading-5 flex-col">
                <h5 className="text-sm font-semibold">{humanizeOrderRequestActionCode(item.actionCode)}</h5>
                {item.message && <p className="text-xs text-black/80 pb-1">{item.message}</p>}
                <p className="text-gray-300 text-xs">
                    {dayjs(item.timestamp).format("HH:mm")} Uhr am {dayjs(item.timestamp).format("DD.MM.YYYY")}
                </p>
            </div>
        ),
        dot:
            item.actionCode === "mark-as-waiting-for-customer-approval" ? (
                <ClockCircleOutlined className="timeline-clock-icon" />
            ) : item.actionCode === "complete" ? (
                <DONE className="h-6 w-6" />
            ) : item.actionCode === "billed" ? (
                <CASH className="h-6 w-6" />
            ) : item.actionCode === "declined" ? (
                <StopOutlined />
            ) : undefined,
        color:
            item.actionCode === "mark-as-waiting-for-customer-approval"
                ? "gold"
                : item.actionCode === "complete"
                ? "green"
                : item.actionCode === "declined"
                ? "red"
                : undefined,
    }))
}
